import React , {useEffect, useState} from 'react'
import { Select, Table } from 'antd'
import GenricModal from 'components/comman/modalComponents/modal/modal';
import SecuredServices from 'api/securedServices';
import SearchBar from 'components/comman/SearchBar/SearchBar';
import { ManageIssuesWrapper } from './ManageIssues.style';

export default function ManageIssues() {
  const columns = [
    {
      title: 'Question Name',
      key: 'q_name',
      render: (text, record) => {
        return (
          <span>Issue-{record.id}</span>
        )}
    },
   
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
     
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <div>
          <button className='showDetailsBtn' onClick={() =>{
            setSelectedData(record);
            setQuestionDetailsModal(true)}}>Show Details</button>
        </div>
      ),
    }
  ];

  const [data,setData] = useState([]);

  

  const [filteredData, setFilteredData] = useState(data);
  const [selectedgrades,setSelectedGrades]= useState([-1]);
  const [selectedtopics,setSelectedTopics] = useState([-1]);
  const [selectedConcepts,setSelectedConcepts] = useState([-1]);
  const [baseUserContentList,setBaseUserContentList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedData,setSelectedData] = useState({});
  const [questionDetailsModal,setQuestionDetailsModal] = useState(false);
  const [optionsData,setOptionsData] = useState({
    topics:[],
    concepts:[],
    grades:[],
  });



  useEffect(() => {
    let topics = [];
    let concepts = [];
    let grades = [];
    data.forEach((item) => {
      if (!topics.some((topic) => topic.topic_id === item.topic_id)) {
        console.log(item,topics,topics.includes(item.topic_id));
        topics.push({
          topic_id: item.topic_id,
          topic_name: item.topic_name,
        });
      }

      if (!concepts.some(topic=>topic.concept_id===item.concept_id)) {
        concepts.push({
          concept_id: item.concept_id,
          concept_name: item.concept_name,
        });
      }
      
      if (!grades.includes(item.grade_id)) {
        grades.push(item.grade_id);
      }
    });
    setOptionsData({
      topics: topics,
      concepts: concepts,
      grades: grades,
    });
  }, [data]);

  useEffect(() => {
    
    SecuredServices.getAllAdminPendingIssuesForCommit().then((res) => {
      console.log(res);
      if(res.data.status==1){
        res.data.data.forEach((item,index)=>{
          item.key = index+1;
        })

        setBaseUserContentList(res.data.data);
        setFilteredData(res.data.data);
        console.log(res.data.data);
     
      }
    }).catch((err) => {
      console.log(err);
    });

  }, []);
  const handleSearchBarChangeForUser = (value) => {
    setData(value);
  }


  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  

  return (
    <ManageIssuesWrapper>
         <div className='flex space-between align-center'>
            <h4 className=''>Manage Issues</h4>
            <div className='' style={{minWidth:"600px"}}>
              <SearchBar data={baseUserContentList} setFilteredData={handleSearchBarChangeForUser} />
            </div>

        </div>
        <div>
        </div>
        <div>
            <Table columns={columns} dataSource={filteredData} rowSelection={rowSelection}/>
        </div>

         <div className='totalRowsSelected'>Total Rows selected : {selectedRowKeys?.length}</div>
        <div className='buttonsSections'>
                <button  className='buttonClass commit'>Commit</button>
              
        </div>

        <GenricModal 
            closable={true}
            width={900}
            title={"Admin Issue Details"}
            data = {selectedData}
            isOpen={questionDetailsModal}
            toggle={()=>{
                setQuestionDetailsModal(false);
            }}
            
        />
      
    </ManageIssuesWrapper>
  )
}
